import {
    DIC
} from '@/const/dic'



export const couponRuleOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    defaultSort:{
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
        label: "规则名称",
        prop: "ruleName",
        type: 'input'
    },
        {
            label: "渠道",
            prop: "channel",
            type: "select",
            dicData: DIC.CHANNEL_TYPE,
        },
        {
            label: "商品名称",
            prop: "goodsName",
            type: 'input'
        },
        {
            label: "服务类目名称",
            prop: "serviceCategoryName",
            type: 'input'
        },
        {
            label: "服务项目名称",
            prop: "serviceItemName",
            type: 'input'
        },
        {
            label: "推广人类型",
            prop: "promoteCustomerType",
            type: "select",
            dicData: DIC.CLIENT_TYPE,
        },
        {
            label: "佣金比例",
            prop: "commissionRate",
            type: 'input'
        },
        {
            label: "上级佣金比例",
            prop: "parentCommissionRate",
            type: 'input'
        },
        {
            label: "省",
            prop: "provinceName",
            type: 'input'
        },
        {
            label: "市",
            prop: "cityName",
            type: 'input'
        },{
            label: "区",
            prop: "areaName",
            type: 'input'
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            span: 30,
            sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
        }
    ]
};